import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

/**
 * Pruh „TESTOVACÍ PROSTŘEDÍ" nahoře na stránce, když backend běží jinde než
 * v produkci (PROSTREDI v jeho .env, např. dev). V produkci se nevykreslí nic.
 *
 * Prostředí říká backend, ne build: frontend je jeden build pro obě prostředí
 * (API volá relativně /api), takže build-time proměnná by nefungovala. Endpoint
 * je veřejný, aby pruh byl vidět už na přihlašovací stránce.
 */
export const ProstrediPruh: React.FC = () => {
  const { data } = useQuery({
    queryKey: ['public-config', 'prostredi'],
    queryFn: async () =>
      (await api.get<{ prostredi: string }>('/public-config/prostredi')).data,
    staleTime: Infinity,
    retry: false,
  });

  const testovaci = !!data && data.prostredi !== 'produkce';

  // Ať se testovací záložka nedá splést s ostrou ani v prohlížeči.
  useEffect(() => {
    if (testovaci && !document.title.startsWith('TEST · ')) {
      document.title = `TEST · ${document.title}`;
    }
  }, [testovaci]);

  if (!testovaci) return null;

  return (
    <div className="bg-orange-500 text-white text-center text-sm font-semibold py-1 px-4">
      TESTOVACÍ PROSTŘEDÍ – data nejsou ostrá, změny se do produkce nepromítnou
    </div>
  );
};
